import { useUserGroups } from '@hooks';
import { IPADetail } from 'components/ProviderData/IpaAdministration/atoms/Models';
import PreferredStatusGrid from 'components/ProviderData/IpaAdministration/organisms/PreferredStatus/PreferredStatusGrid';

const PREFERRED_STATUS_PERMISSION_GROUP = 'Provider Data Manager - Preferred Status';

type PreferredStatusTabProps = {
    ipa: IPADetail;
};
const PreferredStatusTab = ({ ipa }: PreferredStatusTabProps) => {
    const { belongToGroupName } = useUserGroups();
    const isReadOnly = !belongToGroupName(PREFERRED_STATUS_PERMISSION_GROUP);

    return (
        <div className='tab-content tabDiv p-3'>
            <PreferredStatusGrid
                ipa={ipa}
                isReadOnly={isReadOnly}
            />
        </div>
    );
};

export default PreferredStatusTab;
